import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Checkbox, TableSortLabel, Tooltip, Grid, Typography, Box, } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { ReserveRateList, ReserveRateCRU, reserveRateObj, ReserveStatusChange, InvoiceConfiguration, OpeningBalance } from '../components';
import { deleteReserveRateApi, getEscalationDetailsApi, getReserveRateApi, sortReserveRateApi } from '../apiService';
import { getQbStatusApi } from '../../quickBooks/apiService';
import EscalationModal from '../components/EscalationModal';
import CustomTab from '../components/Tab';
import "../styles/reserverate.scss"
import {  LeasesNav, LeasesBasicDetails } from '../../elements';
import { checkApiStatus } from '../../../utils';
import { PageLoader, Pagination, STableLoader, NoRecordFound, hanwahaInstance, jetStreamInstance } from '../../../shared_elements';
import { globalDeleteService, globalGetService, globalPostService } from '../../../utils/globalApiServices';
import { ShowAttachments, DeletePopUp, ButtonLoader } from '../../../shared_elements/components';
import { PermissionWrapper } from '../../../wrappers';
import { RoleBaseAccess } from '../../../hoc';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import { fetchLeaseBasicDetails, getStorage } from '../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { trackActivity } from '../../../utils/mixpanel';
// import AnnualFhFcRatio from '../components/AnnualFhFcRatio';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { closestCenter, DndContext } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { restrictToVerticalAxis, restrictToFirstScrollableAncestor, restrictToParentElement } from '@dnd-kit/modifiers';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 245px)';

const ReserveRateHD = ({ toggleBulkOps, tableSorting, item, bulk, leaseBasicDetails, isQbEnabled }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['D'] }}>
                        {leaseBasicDetails?.is_reserve_rate === 0 ?
                            <Tooltip title="Select All" arrow placement='top'><Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} /></Tooltip> : null}
                    </PermissionWrapper>
                    <span >Action(s)</span>
                </TableCell>
                <TableCell sx={{ minWidth: "100px" }}> {tableSorting('status', 'Status')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('name', 'Reserve Name')} </TableCell>
                <TableCell sx={{ minWidth: "140px" }}>{tableSorting('reserve_rate_type', "Reserve Type")}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('account_type', 'Account Type')}  </TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('major_assembly', 'Major Assembly')}  </TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('interval', 'Interval')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('reserve_rate_per_interval', 'Rate')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('rate_start_date', 'Start Date')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('rate_end_date', 'End Date')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('rate_escalation_percentage', 'Escalation')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('rate_escalation_interval', 'Esc. Interval')}</TableCell>
                <TableCell sx={{ minWidth: "140px" }}> {tableSorting('rate_escalation_start_date', 'Esc. Start Date')}</TableCell>
                {isQbEnabled && <TableCell sx={{ minWidth: "160px" }}>Product & Service</TableCell>}
                {isQbEnabled && <TableCell sx={{ minWidth: "160px" }}>Chart of Account</TableCell>}
                {isQbEnabled && hanwahaInstance && <TableCell sx={{ minWidth: "160px" }}>Class</TableCell>}
                {isQbEnabled && hanwahaInstance && <TableCell sx={{ minWidth: "160px" }}>Sub Class</TableCell>}
                {/* <TableCell> {tableSorting('starting_fund_amount', 'Starting Fund Amount')}</TableCell> */}
            </TableRow>
        </TableHead>
    );
};

const ReserveRate = () => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const { enqueueSnackbar } = useSnackbar();
    const { leaseBasicDetails, fileUploadDetails } = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false)
    const [reserveRateInfo, setReserveRateInfo] = useState({ list: [], pagination: { page: 1, per_page: 50 } });
    const [isExport, seIsExport] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState({initialLoader:true,escalationLoader:false});
    const [addEditReserveRate, setAddEditReserveRate] = useState({ mode: '', modal: false, data: reserveRateObj })
    const [deleteReserveRate, setDeleteReserveRate] = useState({ modal: false, data: null });
    const [changeStatusLeases, setChangeStatusLeases] = useState({ mode: '', modal: false, data: null })
    const [queryConfig, setQueryConfig] = useState({
        page: reserveRateInfo?.pagination?.page || 1,
        per_page: reserveRateInfo?.pagination?.per_page || 50,
    });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [escalationView, setEscalationView] = useState({ mode: '', modal: false, data: null,item:null });
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [tabIndex, setTabIndex] = useState(0);
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [isQbEnabled, setIsQbEnabled] = useState(false);
    const [qbStatusLoading, setQbStatusLoading] = useState(jetStreamInstance || hanwahaInstance);

    const getReserveRateList = (query, type) => {
        if (type === "initial") {setSkeletonLoader({initialLoader:true}) } else {setLoading(true) }
        globalGetService(getReserveRateApi(params, query))
            .then(response => {
                setSkeletonLoader({initialLoader :false});
                setLoading(false)
                if (checkApiStatus(response)) {
                    setReserveRateInfo(response?.data?.data)
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error",hideIconVariant:true, anchorOrigin: { vertical: "top", horizontal: "right" }, })
                }
            });
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "eol_obligation" }))
    };
    const getEscalationDetails = (loaderType, rentalSlug ) => {
        loaderType === 'escalationLoader' ? setSkeletonLoader({escalationLoader:true}) : setLoading(true);
        globalGetService(getEscalationDetailsApi(params, rentalSlug)).then(response => {
            loaderType === 'escalationLoader' ? setSkeletonLoader({escalationLoader:false}) : setLoading(false);
            if (checkApiStatus(response)) {
                setEscalationView(prev => ({ ...prev, modal: true, data: response?.data?.data }));
            }
        });
    }
    useEffect(() => {
        const uploadedFileData = getApiResponse("reserve_rates", slug);
        setUploadFileProgressData({ uploadedFileData });
        trackActivity('Page Viewed', { page_title: 'Reserve Rates' })
        globalGetService(getQbStatusApi()).then(response => {
            if (checkApiStatus(response)) {
                setIsQbEnabled(response.data.data?.is_lessor_enabled);
            }
            setQbStatusLoading(false);
        });
    }, []);
    useEffect(() => {
        if (!leaseBasicDetails?.status) return;
        getReserveRateList(queryConfig, "initial");
    }, [leaseBasicDetails?.status]);
    const createSortHandler = (key) => {
        const isAsc = queryConfig.sort_by === key && queryConfig.sort === 'asc';
        const updatedSort = isAsc ? 'desc' : 'asc';
        setQueryConfig({
            page: reserveRateInfo?.pagination?.page || 1,
            per_page: reserveRateInfo?.pagination?.per_page || 20,
            sort_by: key,
            sort: updatedSort
        });
        getReserveRateList({
            page: reserveRateInfo?.pagination?.page || 1,
            per_page: reserveRateInfo?.pagination?.per_page || 20,
            sort: updatedSort,
            sort_by: key,
        }, "");
    };

    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={queryConfig.sort_by === key}
                direction={queryConfig.sort_by === key ? queryConfig.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )
    }

    const onDeleteReserveRate = () => {
        setLoading(true);
        const idsToDelete = bulk?.modal ? (bulk?.ids || []).map(item => item?.id) : [deleteReserveRate?.data?.id];
        // (bulk?.type === 'bulk' || bulk?.type === 'single') && bulk.modal  ? bulk?.ids?.map(item => item?.id) : [deleteReserveRate?.data?.id]
        globalDeleteService(deleteReserveRateApi(params), { ids: idsToDelete } )
        .then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                trackActivity('Item Deleted', { page_title: `Delete Reserve Rate`, success_msg: response?.data?.message, item_ids: deleteReserveRate?.data || bulk?.ids, response: response?.data })
                setDeleteReserveRate({ modal: false, data: null });
                dispatch(fetchLeaseBasicDetails({ slug: params?.leaseSlug, setLoading }));
                setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                enqueueSnackbar(response?.data?.message, { variant: "success",hideIconVariant:true, anchorOrigin: { horizontal: "right", vertical: "top" }, });
                getReserveRateList(queryConfig, "");
            }
        });
    };

    const toggleBulkOps = async (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else { setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) }) }
    }
    const onDeleteAttachments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditReserveRate?.modal) {
            setAddEditReserveRate({
                ...addEditReserveRate,
                data: {
                    ...addEditReserveRate.data,
                    attachments: addEditReserveRate.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getReserveRateList(queryConfig, "");
    }

    const handleExport = () => {
        let query = { export: true }
        if (queryConfig?.sort && queryConfig?.sort_by) {
            query = {
                ...query,
                sort: queryConfig?.sort,
                sort_by: queryConfig?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getReserveRateApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success",hideIconVariant:true, anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

  
    const handleUpload = async (slug,mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "reserve_rates",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getReserveRateList(queryConfig, "initial");;
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    }
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;
        const oldIndex = reserveRateInfo.list.findIndex(item => item.slug === active.id);
        const newIndex = reserveRateInfo.list.findIndex(item => item.slug === over.id);
        const reorderedList = arrayMove(reserveRateInfo.list, oldIndex, newIndex);
        setReserveRateInfo(prev => ({ ...prev, list: reorderedList }));
        const payload = reorderedList.map((item, index) => ({ id: item.id, order: index + 1 }));
        globalPostService(sortReserveRateApi(params), payload)
            .then(response => {
                if (!checkApiStatus(response)) {
                    setReserveRateInfo(prev => ({ ...prev, list: reserveRateInfo.list }));
                    enqueueSnackbar(response?.data?.message || 'Failed to save order', { variant: 'error', hideIconVariant: true, anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
                else{
                    enqueueSnackbar('Row Order Updated Successfully', { variant: "success",hideIconVariant:true, anchorOrigin: { horizontal: "right", vertical: "top" }, });
                }
            });
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Reserve Rates`, page_type: page_type, })
    }
    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                    <div className='lease-details-content'>
                        <Paper square className="responsive-paper">
                            <Grid container className="responsive-grid" spacing={1} alignItems='flex-end'>
                                <Grid size={{ md: 12 }}>
                                    <CustomTab value={tabIndex} onChange={(e, val) => setTabIndex(val)} />
                                </Grid>
                                {tabIndex === 0 && <>
                                    <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                                        <BackToLeaseList />
                                    </Grid>
                                    <Grid item size={{ md: 8, xs: 12 }}>
                                        <ul className='list-inline lease-details-right-items lease-details-btn' style={{ float: 'right', padding: '0px' }}>
                                            <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /></li>
                                            {bulk?.type && bulk?.ids?.length ? <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null}
                                            {reserveRateInfo?.list?.length > 0 ? <li className='lease-mobile-button'><Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'>Export</Button></li> : null}
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['C'] }}>
                                                {leaseBasicDetails?.is_reserve_rate === 0 ?
                                                    <li className='lease-mobile-button'><Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditReserveRate({ modal: true, data: reserveRateObj, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Reserve Rate</Button></li>
                                                    : null}
                                            </PermissionWrapper>
                                        </ul>
                                    </Grid>
                                </>}
                            </Grid>
                        </Paper>
                        {tabIndex === 1 ? <InvoiceConfiguration /> : null}
                        {/* {tabIndex === 2 ? <AnnualFhFcRatio /> : null} */}
                        {tabIndex === 2 ? <OpeningBalance /> : null}
                        {tabIndex === 0 ?
                            <Paper className='lease-detail-table table-tab-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: reserveRateInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                                <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0, boxSizing: 'border-box' }}>
                                    {(skeletonLoader?.initialLoader || qbStatusLoading) ? <STableLoader count={6} rowCount={11} /> : (
                                        <DndContext
                                            collisionDetection={closestCenter}
                                            onDragEnd={handleDragEnd}
                                            modifiers={[restrictToVerticalAxis, restrictToParentElement, restrictToFirstScrollableAncestor]}
                                        >
                                            <Table className="mui-table-format" stickyHeader sx={{ minWidth: `${window.innerWidth + 320}px` }}>
                                                <ReserveRateHD tableSorting={tableSorting} queryConfig={queryConfig} item={reserveRateInfo?.list} bulk={bulk} toggleBulkOps={toggleBulkOps} leaseBasicDetails={leaseBasicDetails} isQbEnabled={isQbEnabled} />
                                                <TableBody>
                                                    <SortableContext items={reserveRateInfo?.list?.map(item => item.slug)} strategy={verticalListSortingStrategy}>
                                                        {reserveRateInfo?.list?.length > 0 && (
                                                            reserveRateInfo.list.map((item) => {
                                                                const uploadedFileData = getApiResponse("reserve_rates", item?.slug);
                                                                return (
                                                                    <ReserveRateList
                                                                        key={item.slug}
                                                                        slug={slug?.slug}
                                                                        uploadedFileData={uploadedFileData}
                                                                        uploadFileProgressData={uploadFileProgressData}
                                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                                        leaseBasicDetails={leaseBasicDetails}
                                                                        item={item}
                                                                        isQbEnabled={isQbEnabled}
                                                                        bulk={bulk}
                                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                                        viewFile={() => setUploadfileList({ modal: true, mode: 'file', data: item })}
                                                                        deleteReserveRate={deleteReserveRate}
                                                                        toggleBulkOps={toggleBulkOps}
                                                                        onEdit={() => { setAddEditReserveRate({ modal: true, mode: 'edit', data: item, }) }}
                                                                        onDelete={() => {
                                                                            setDeleteReserveRate({ modal: true, data: item });
                                                                            setBulk({ modal: false, ids: [], title: '', type: '' });
                                                                        }}
                                                                        onView={() => { setAddEditReserveRate({ modal: true, mode: 'view', data: item, }) }}
                                                                        onEscalationView={() => { setEscalationView(prev => ({ ...prev, modal: true, item: item })); getEscalationDetails("escalationLoader", item?.slug) }}
                                                                        statusChange={() =>
                                                                            setChangeStatusLeases({
                                                                                modal: true,
                                                                                data: item,
                                                                                mode: "add",
                                                                            })
                                                                        }
                                                                    />
                                                                );
                                                            })
                                                        )}
                                                    </SortableContext>
                                                </TableBody>
                                            </Table>
                                        </DndContext>
                                    )}
                                </div>
                                <Paper>
                                    {!skeletonLoader?.initialLoader && !reserveRateInfo?.list?.length && <NoRecordFound />}
                                    <Pagination
                                        pagination={reserveRateInfo?.pagination}
                                        onPageChange={(event, newPage) => getReserveRateList({ ...queryConfig, page: newPage + 1, per_page: reserveRateInfo?.pagination?.per_page }, 'pageLoader')}
                                        onRowsPerPageChange={(e) => getReserveRateList({ ...queryConfig, page: 1, per_page: e.target.value }, 'pageLoader')}
                                    />
                                </Paper>
                            </Paper> : null}
                    </div>}
            </Paper>
            {uploadfileList?.modal ?
                <ShowAttachments
                    url='delete-attachment'
                    moduleName="Reserve Rates"
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeleteAttachments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode: '' })}
                    onViewDisabled={addEditReserveRate?.mode === 'view' || uploadfileList?.mode === 'view'}
                    permissionKey='reserve_rates'
                /> : null
            }
            {addEditReserveRate?.modal ?
                <ReserveRateCRU
                    fileUpload={handleUpload}
                    params={params}
                    modeType={addEditReserveRate?.mode}
                    addEditReserveRate={addEditReserveRate}
                    getResponseBack={() => {getReserveRateList(queryConfig, ""); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onToggleModal={() => setAddEditReserveRate({ modal: false, mode: '', data: reserveRateObj })}
                    onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditReserveRate?.data, mode: 'view' })}
                /> : null
            }

            {deleteReserveRate?.modal ?
                <DeletePopUp
                    modal={deleteReserveRate.modal}
                    title="Delete Reserve Rate"
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteReserveRate({ modal: false, data: null })}
                    onDeleteRecords={onDeleteReserveRate}
                /> : null
            }
            {bulk?.modal ?
                <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk?.ids?.length && bulk.ids.length === (reserveRateInfo?.list?.length || 0) ? 'All Reserve Rates' : 'Selected Reserve Rate'}`}
                    onDeleteRecords={onDeleteReserveRate}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [], title: '', type: '' })}
                /> : null
            }
            {
                changeStatusLeases?.modal &&
                <ReserveStatusChange
                    params={params}
                    queryConfig={queryConfig}
                    getReserveRateList={getReserveRateList}
                    changeStatusLeases={changeStatusLeases}
                    getResponseBack={() => setChangeStatusLeases({ ...changeStatusLeases, modal: false, mode: '', data: null })}
                    onToggleModal={() => setChangeStatusLeases({ ...changeStatusLeases, modal: false, mode: '', data: null })} />
            }
            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"reserve_rates"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            {
                escalationView.modal &&
                <EscalationModal
                    moduleName={"escalation_details"}
                    escalationData={escalationView}
                    onToggleModal={() => setEscalationView({ modal: false, mode: '', data: null, item: null })}
                    handleItemClicked={handleItemClicked}
                    skeletonLoader={skeletonLoader?.escalationLoader}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(ReserveRate, { application: 'lease_revamp', feature: 'reserve_rates', operationType: ['R'] });
